/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetDeliverFeeKrAmountlListRespVo } from './GetDeliverFeeKrAmountlListRespVo';
import {
    GetDeliverFeeKrAmountlListRespVoFromJSON,
    GetDeliverFeeKrAmountlListRespVoFromJSONTyped,
    GetDeliverFeeKrAmountlListRespVoToJSON,
    GetDeliverFeeKrAmountlListRespVoToJSONTyped,
} from './GetDeliverFeeKrAmountlListRespVo';

/**
 * 
 * @export
 * @interface GetDeliverFeeKrListRespVo
 */
export interface GetDeliverFeeKrListRespVo {
    /**
     * 仓库id
     * @type {number}
     * @memberof GetDeliverFeeKrListRespVo
     */
    warehouseId?: number;
    /**
     * 运输方式id
     * @type {number}
     * @memberof GetDeliverFeeKrListRespVo
     */
    transportMethodId?: number;
    /**
     * 韩国国内运费分组：1橙火服务，2韩国3PL出库
     * @type {number}
     * @memberof GetDeliverFeeKrListRespVo
     */
    orderTypeGroup?: number;
    /**
     * 用户等级id
     * @type {number}
     * @memberof GetDeliverFeeKrListRespVo
     */
    gradeId?: number;
    /**
     * 用户等级名称
     * @type {string}
     * @memberof GetDeliverFeeKrListRespVo
     */
    gradeName?: string;
    /**
     * 重量-金额信息
     * @type {Array<GetDeliverFeeKrAmountlListRespVo>}
     * @memberof GetDeliverFeeKrListRespVo
     */
    gradeAmounts?: Array<GetDeliverFeeKrAmountlListRespVo>;
}

/**
 * Check if a given object implements the GetDeliverFeeKrListRespVo interface.
 */
export function instanceOfGetDeliverFeeKrListRespVo(value: object): value is GetDeliverFeeKrListRespVo {
    return true;
}

export function GetDeliverFeeKrListRespVoFromJSON(json: any): GetDeliverFeeKrListRespVo {
    return GetDeliverFeeKrListRespVoFromJSONTyped(json, false);
}

export function GetDeliverFeeKrListRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetDeliverFeeKrListRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'warehouseId': json['warehouseId'] == null ? undefined : json['warehouseId'],
        'transportMethodId': json['transportMethodId'] == null ? undefined : json['transportMethodId'],
        'orderTypeGroup': json['orderTypeGroup'] == null ? undefined : json['orderTypeGroup'],
        'gradeId': json['gradeId'] == null ? undefined : json['gradeId'],
        'gradeName': json['gradeName'] == null ? undefined : json['gradeName'],
        'gradeAmounts': json['gradeAmounts'] == null ? undefined : ((json['gradeAmounts'] as Array<any>).map(GetDeliverFeeKrAmountlListRespVoFromJSON)),
    };
}

export function GetDeliverFeeKrListRespVoToJSON(json: any): GetDeliverFeeKrListRespVo {
    return GetDeliverFeeKrListRespVoToJSONTyped(json, false);
}

export function GetDeliverFeeKrListRespVoToJSONTyped(value?: GetDeliverFeeKrListRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'warehouseId': value['warehouseId'],
        'transportMethodId': value['transportMethodId'],
        'orderTypeGroup': value['orderTypeGroup'],
        'gradeId': value['gradeId'],
        'gradeName': value['gradeName'],
        'gradeAmounts': value['gradeAmounts'] == null ? undefined : ((value['gradeAmounts'] as Array<any>).map(GetDeliverFeeKrAmountlListRespVoToJSON)),
    };
}

